import PropTypes from "prop-types";
import { useEffect, useMemo } from "react";
// @mui
import {
  alpha,
  ThemeProvider,
  createTheme,
  useTheme,
} from "@mui/material/styles";
// hooks
import useSettings from "../../hooks/useSettings";
import get from "lodash/get";
import componentsOverride from "../../theme/overrides";
import { useAppConfiguration } from "../../global/configs/appConfig";
import getColorPresets from "../../utils/getColorPresets";

// ----------------------------------------------------------------------

ThemeColorPresets.propTypes = {
  children: PropTypes.node,
};

export default function ThemeColorPresets({ children }) {
  const defaultTheme = useTheme();

  const { setColor, themeColorPresets, onChangeColor } = useSettings();
  const { appConfig } = useAppConfiguration();
  useEffect(() => {
    if (!get(appConfig, "themeSettings.isActive")) onChangeColor("default");
    onChangeColor(get(appConfig, "themeSettings.selectedTheme.primary"));
  }, [appConfig]);
  const themeOptions = useMemo(() => {
    return {
      ...defaultTheme,
      palette: {
        ...defaultTheme.palette,
        // primary: {
        //   ...defaultTheme.palette.primary,
        //   // main: "#0052cc", CHANGE COLOR HERRE
        // },
        primary: setColor,
        ...(get(appConfig, "themeSettings.selectedTheme.secondary") && {
          secondary: getColorPresets(
            get(appConfig, "themeSettings.selectedTheme.secondary")
          ),
        }),
      },
      customShadows: {
        ...defaultTheme.customShadows,
        primary: `0 8px 16px 0 ${alpha(setColor.main, 0.24)}`,
      },
    };
  }, [setColor, appConfig, defaultTheme, themeColorPresets]);

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
